module.exports = __webpack_public_path__ + "img/feed@3x.32b2420.png";